import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import keymaster from 'keymaster';
import moment from 'moment';
import { logEntrySorter } from '../utils/sorting';
import DurationFormatter from '../utils/duration';

import DatePicker from 'react-datepicker';
import NewLogEntryWidget from './NewLogEntryWidget';
import ShowPill from './ShowPill';
import Spinner from './Spinner';

require.ensure([], () => {
   require('./DatePicker.less')
   require('./LogEntryListWidget.less');
    require('./Material-Design-Iconic.less');
});

class LogEntryListWidget extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.logEntry = [];
        this.state = {
            createLogEntry: false,
            date: this.props.date,
            logEntries: [],
            tasks: [],
            regularMinutesLogged: 0,
            overtimeMinutesLogged: 0,
            fillTaskForLogEntry: this.props.fillTaskForLogEntry
        };
    }

    // LIFECYCLE METHODS

    componentDidMount = () => {
        keymaster('left', this.decrementDate);
        keymaster('right', this.incrementDate);
    }

    componentWillReceiveProps = (nextProps) => {
        // date changed so get new log entries and set new state
        let logEntries = nextProps.logEntries;
        logEntries.sort(logEntrySorter);
        let regularMinutesLogged = 0;
        let overtimeMinutesLogged = 0;

        for (let i = 0 ; i < nextProps.logEntries.length; ++i) {
            if (nextProps.logEntries[i].timer)
                continue;

            let duration = nextProps.logEntries[i].duration;

            if (duration === null || duration === undefined  || isNaN(duration))
                continue;

            if (!nextProps.logEntries[i].overtime) {
                regularMinutesLogged += parseInt(duration);
            } else {
                overtimeMinutesLogged += parseInt(duration);
            }
        }

        // merge floating tasks and other tasks into single array
        let tasks = [];
        tasks = tasks.concat(nextProps.floatingTasks);
        tasks = tasks.concat(nextProps.tasks);

        this.setState({
            logEntries: logEntries,
            date: nextProps.date,
            tasks: tasks,
            regularMinutesLogged: regularMinutesLogged,
            overtimeMinutesLogged: overtimeMinutesLogged,
            fillTaskForLogEntry: nextProps.fillTaskForLogEntry
        });
    }

    componentWillUnmount = () => {
        keymaster.unbind('left');
        keymaster.unbind('right');
    }

    // EVENT HANDLERS

    handleCalendarClick = () => {
        this.setState({
            selectDate: true
        }, () => {
            if (this.datePicker)
                this.datePicker.handleFocus();
            else
                setTimeout(this.datePicker.handleFocus, 100);
        });

        setTimeout(() => {
            moment.updateLocale('en', {
                week: { doy: 4, dow: 1 }
            });
        }, 150);
    }

    handleDateChange = (date) => {
        this.props.handleDateChange(date);
        this.setState({
            selectDate: false
        });
    }

    handleKeyDown = (keyEvent) => {
        // closes the new entry pill
        if (keyEvent.key === "Escape") {
            this.props.setFillTaskForLogEntry(null);
            this.setState({
                createLogEntry: false
            });
        } else if (keyEvent.key === "Insert") {
            this.props.setFillTaskForLogEntry(null);
            this.setState({
                createLogEntry: true
            });
        }
    }

    // OTHER METHODS

    returnKeymaster = () => {
        keymaster.unbind('left');
        keymaster.unbind('right');
        keymaster('left', this.decrementDate);
        keymaster('right', this.incrementDate);
    }

    closeAllPopovers = () => {
        for (let i = 0; i < this.state.logEntries.length; ++i) {
            let logEntry = this.logEntry[i];

            if (logEntry.handlePopoverClose)
                logEntry.handlePopoverClose();
        }
    }

    createLogEntry = (logEntry) => {
        this.props.createLogEntry(logEntry);

        this.setState({
            createLogEntry: false
        });
    }

    decrementDate = () => {
        this.setState({
            selectDate: false
        });
        this.props.decrementDate();
    }

    incrementDate = () => {
        this.setState({
            selectDate: false
        });
        this.props.incrementDate();
    }

    toggleCreateLogEntry = () => {
        if (this.state.createLogEntry)
            this.props.setFillTaskForLogEntry(null);

        this.setState({
            createLogEntry: true
        });
    }

    unsetCreateLogEntry = () => {
        this.props.setFillTaskForLogEntry(null);

        this.setState({
            createLogEntry: false,
            fillTaskForLogEntry: null
        });
    }

    // RENDER METHOD

    render = () => {
        let disabled = this.props.timesheet && this.props.timesheet.status !== "ENTRY" && this.props.timesheet.status !== "FIXING";

        let createModal = (
            <NewLogEntryWidget
                createLogEntry={this.createLogEntry}
                date={this.state.date}
                editForUser={this.props.editForUser}
                fillTaskForLogEntry={this.state.fillTaskForLogEntry}
                infoUserTask={this.props.infoUserTask}
                key={this.state.fillTaskForLogEntry}
                onRequestHide={this.unsetCreateLogEntry}
                returnKeymaster={this.returnKeymaster}
                tasks={this.state.tasks}
                timesheet={this.props.timesheet}
                user={this.props.currentUser}
                />
        );

        let dayClass = moment().format("DD-MM-YYYY") === this.state.date.format("DD-MM-YYYY") ? "label-day today" : "label-day";

        if (this.props.loading) {
            return (
                <div className="panel panel-day-single panel-default">
                    <div className="panel-heading">
                        <div className="panel-title">
                            <h4>My Work Log</h4>
                            <div className="panel-log-date">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <i className="md-chevron-left md-lg" onClick={this.decrementDate}></i>
                                        <span className={dayClass}><span style={{ "display": "inline-block" }}>{this.state.date.format("dddd DD.MM.YYYY.")}</span></span>
                                        <i className="md-chevron-right md-lg" onClick={this.incrementDate}></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="panel-body tasks">
                        <span style={{"padding" : "200px"}}/>
                        <Spinner />
                        <span style={{"padding" : "200px"}}/>
                    </div>
                </div>
            );
        }

        return (
            <div className="panel panel-day-single panel-default">
                <div className="panel-heading">
                    <div className="panel-title">
                        <h4>My Work Log</h4>
                        <div className="panel-log-date">
                            <div className="row">
                                <div className="col-lg-12">
                                    <i className="md-chevron-left md-lg" onClick={this.decrementDate}></i>

                                    <span className={dayClass}><span style={{ "display": "inline-block" }}>
                                    {
                                    this.state.selectDate ?
                                        <span className="no-show" style={{ display: "inline-block" }}><i onClick={this.handleCalendarClick} className="md-today"/>&nbsp;&nbsp;
                                            <DatePicker
                                                className="hideInput"
                                                ref={ref => this.datePicker = ref}
                                                dateFormat="YYYY-MM-DD"
                                                selected={this.props.date}
                                                onChange={this.handleDateChange}
                                                />
                                        </span>
                                    :
                                    <span><i onClick={this.handleCalendarClick} className="md-today"/>&nbsp;&nbsp;</span>
                                    }
                                    {this.state.date.format("dddd DD.MM.YYYY.")}
                                    </span></span>
                                    <i className="md-chevron-right md-lg" onClick={this.incrementDate}></i>
                                </div>
                            </div>
                            <div className="total-logged-show">
                                {DurationFormatter.format(this.state.regularMinutesLogged)}&nbsp;+&nbsp;<em style={{color: "#cc2200"}}>{DurationFormatter.format(this.state.overtimeMinutesLogged)}</em>
                            </div>
                        </div>
                        <div className="timesheet-status-show">
                            <span>
                                { this.props.timesheet && this.props.timesheet.status === "APPROVED" ? "Approved" : null }
                                { this.props.timesheet && this.props.timesheet.status === "SUBMITTED" ? "Submitted" : null }
                            </span>
                        </div>
                    </div>
                </div>

                {
                    this.state.createLogEntry || this.state.fillTaskForLogEntry !== null
                    ? createModal
                    : null
                }

                <div className="panel-body tasks">
                    <div className="scrollable-div">
                        <ul>
                        {
                            this.state.logEntries.map((logEntry, i) => {
                                return <ShowPill
                                            closeAllPopovers={this.closeAllPopovers}
                                            createLogEntry={this.props.createLogEntry}
                                            editForUser={this.props.editForUser}
                                            getLog = {(yourself) => {this.logEntry[i] = yourself}}
                                            id={i}
                                            key={i}
                                            loadTimesheet={this.props.loadTimesheet}
                                            logEntries={this.state.logEntries}
                                            logEntry={logEntry}
                                            modalPopover
                                            smartPopoverPlacement={false}
                                            tasks={this.state.tasks}
                                            timesheet={this.props.timesheet}
                                            updateLogEntry={this.props.updateLogEntry}
                                           />;
                            })
                        }
                        </ul>
                    </div>
                </div>

                {
                    disabled ? null :
                    <div className="panel-footer" style={{"textAlign" : "center"}}>
                    {
                        moment().subtract(31, 'days').isBefore(this.props.date) ?
                            <Button className="btn btn-default btn-large btn-centered" title="Add a new work log" onClick={this.toggleCreateLogEntry}>NEW</Button>
                            :
                            <span>Please contact Tashi Support if you wish to edit this day.</span>
                    }
                    </div>
                }
            </div>
        );
    }
}

LogEntryListWidget.propTypes = {
    createLogEntry: PropTypes.func,
    currentUser: PropTypes.object,
    date: PropTypes.object,
    decrementDate: PropTypes.func,
    editForUser: PropTypes.object,
    fillTaskForLogEntry: PropTypes.object,
    floatingTasks: PropTypes.array,
    handleDateChange: PropTypes.func,
    incrementDate: PropTypes.func,
    infoUserTask: PropTypes.object,
    loadTimesheet: PropTypes.func,
    loading: PropTypes.bool,
    logEntries: PropTypes.array,
    setDate: PropTypes.func,
    setFillTaskForLogEntry: PropTypes.func,
    tasks: PropTypes.array,
    timesheet: PropTypes.object,
    updateLogEntry: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
        currentUser: state.users.currentUser
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LogEntryListWidget);



/** WEBPACK FOOTER **
 ** ./src/app/components/LogEntryListWidget.js
 **/